/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { NG_VALIDATORS } from '@angular/forms'
import { dateValidator, emailRfcValidator, mobileValidator } from './validators'
import { DYNAMIC_VALIDATORS } from '@myprofile-ui/myprofile-dynamic-forms'

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: NG_VALIDATORS,
      useValue: emailRfcValidator,
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useValue: mobileValidator,
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useValue: dateValidator,
      multi: true,
    },
    {
      provide: DYNAMIC_VALIDATORS,
      useValue: new Map([
        ['emailRfc', emailRfcValidator],
        ['mobile', mobileValidator],
        ['dob', dateValidator],
      ]),
    },
  ],
})
export class ValidatorsModule {}
